export default "https://assets.pclncdn.com/web/next-landing/d6942e80/_next/static/images/Three-a112201b65eb30d1dfecbdd118ebcc92.svg";